module.exports = __webpack_public_path__ + "img/P2 (2).66aed631.png";